import { useAuthStore }    from '../store/authStore.js';
import { useSessionStore } from '../store/sessionStore.js';
import { useCartStore }    from '../store/cartStore.js';
import { useTabsStore }    from '../store/tabsStore.js';
import { useWaiterStore }  from '../store/waiterStore.js';

// Cerrar sesión en este aparato, desde cualquier pantalla. Solo existía en la
// apertura de caja, a la que una comandera nunca llega: un celular de mesero no
// tenía forma de salir de la cuenta con la que se configuró.
//
// No cierra el turno: el turno es del cajón y queda abierto en el servidor;
// quien vuelva a entrar en esta caja lo retoma desde la apertura. Lo que se
// suelta es lo de este aparato: la cuenta que tenía abierta, el carrito y el
// mesero identificado.
export function cerrarSesion() {
  useCartStore.getState().clearCart();
  useTabsStore.getState().clearActiveTab();
  useWaiterStore.getState().clearWaiter();
  useSessionStore.getState().closeSession();
  useAuthStore.getState().logout();
}
